import { getAdminUrl } from "@pathwright/utils/src/url/admin"
import {
  PathwrightContext,
  usePathwrightContext
} from "../pathwright/PathwrightContext"
import { getModelInfo } from "./PWAdminHint"
import { PWAdminCmdKOption, PWAdminHintModel } from "./types"
import { usePWAdminSSOLinks } from "./usePWAdminSSOLink"

export function getSupportInfo({
  context,
  model,
  authLink,
  pwAdminAuthLink
}: {
  context: PathwrightContext
  model?: PWAdminHintModel
  authLink: string
  pwAdminAuthLink: string
}) {
  const { school, me } = context
  const adminSchoolUrl = getAdminUrl(`admin/school/school/${school.id}/`)
  const adminUserUrl = getAdminUrl(`admin/auth/user/${me?.id}/`)

  // School ID, name, URL as Markdown, table format
  const schoolInfo = `| | ID | Name | Address | Admin |
| ----------- | ----------- | ----------- | ----------- | ----------- |
| **School** | ${school.id} | ${school.name} | [${school.url}](${school.url}) | [${adminSchoolUrl}](${adminSchoolUrl}) |`

  let userInfo = ""
  let modelInfo = ""

  if (me) {
    userInfo = `| ----------- | ----------- | ----------- | ----------- | ----------- |
| **User** | ${me.id} | ${me.full_name} | [${me.email}](${me.email}) | [${adminUserUrl}](${adminUserUrl}) |`
  }

  if (
    model &&
    model.__typename !== school.__typename &&
    model.__typename !== me?.__typename
  ) {
    const data = getModelInfo(model, school)
    const uiLink = data.options.find((option) => option.label === "View in UI")
    const adminLink = data.options.find(
      (option) => option.label === "View in Admin"
    )

    if (uiLink && adminLink && "href" in uiLink && "href" in adminLink) {
      modelInfo = `| ----------- | ----------- | ----------- | ----------- | ----------- |
| **${data.type}** | ${data.id} | ${data.label} | [${uiLink?.href}](${uiLink?.href}) | [${adminLink?.href}](${adminLink?.href}) |`
    }
  }

  let links = `\n- Link: [${window.location.href}](${window.location.href})`
  // Conditionally include the link to auth as current user when there is a current user.
  if (me) {
    links += `\n  - [View as ${me.full_name}](${authLink})`
  }
  links += `\n  - [View as Superuser](${pwAdminAuthLink})`

  // NOTE: to separate tables, Linear doesn't simply respect a blank line,
  // so we add a space on the newline, which does work.
  return `${schoolInfo}${userInfo}${modelInfo}${links}\n---`
}

function useSupportInfo(model?: PWAdminHintModel): PWAdminCmdKOption {
  const pwContext = usePathwrightContext()
  const { currentUrl } = usePWAdminSSOLinks({ userScope: "current" })
  const { currentUrl: currentProxierUrl } = usePWAdminSSOLinks({
    userScope: "proxier"
  })

  const link: PWAdminCmdKOption = {
    key: "copy-support-info",
    icon: "caution-circle",
    label: "Copy Support Info",
    copy: getSupportInfo({
      context: pwContext,
      model,
      authLink: currentUrl,
      pwAdminAuthLink: currentProxierUrl
    })
  }

  return link
}

export default useSupportInfo
